import type { GameItem, GameSubTab } from '../types/game-content'
import type { HomeApiCategoryVendor, HomeApiRecommendedGame } from '../types/home-aggregate'

/** /games 或 /home.recommended_games 单项 → 卡片 GameItem */
export function mapApiGameToItem(item: HomeApiRecommendedGame): GameItem {
  return {
    id: String(item.id),
    title: item.name || '未命名游戏',
    imageUrl: (item.cover ?? '').trim(),
    imageKey: (item.cover_key ?? '').trim() || undefined,
    provider: item.vendor?.display_name || item.vendor?.vendor_code || '',
    providerIconUrl: (item.vendor?.logo_url ?? '').trim() || undefined,
    providerIconKey: (item.vendor?.logo_key ?? '').trim() || undefined,
    isFavorite: typeof item.is_favorite === 'boolean' ? item.is_favorite : undefined,
  }
}

/** home category.vendors → 侧栏 GameSubTab */
export function mapApiVendorToSubTab(vendor: HomeApiCategoryVendor): GameSubTab {
  return {
    id: vendor.vendor_code || String(vendor.vendor_id),
    label: vendor.display_name || vendor.vendor_code || '厂商',
    iconUrl: (vendor.logo_url ?? '').trim() || undefined,
    iconKey: (vendor.logo_key ?? '').trim() || undefined,
    status: vendor.status,
    vendorId: vendor.vendor_id,
  }
}
